<template>

<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-1" d="m36.35,36.49c1.17,0,2.17.99,2.17,2.17v35.17c0,1.17-.99,2.17-2.17,2.17h-17.72c-1.17,0-2.17-.99-2.17-2.17v-35.17c0-1.17.99-2.17,2.17-2.17h17.72m0-4h-17.72c-3.39,0-6.17,2.77-6.17,6.17v35.17c0,3.39,2.77,6.17,6.17,6.17h17.72c3.39,0,6.17-2.77,6.17-6.17v-35.17c0-3.39-2.77-6.17-6.17-6.17h0Z"/>
  <path class="cls-2" d="m37.07,14.01c.78,0,1.44.66,1.44,1.44v6.93c0,.78-.66,1.44-1.44,1.44h-19.17c-.78,0-1.44-.66-1.44-1.44v-6.93c0-.78.66-1.44,1.44-1.44h19.17m0-4h-19.17c-2.99,0-5.44,2.45-5.44,5.44v6.93c0,2.99,2.45,5.44,5.44,5.44h19.17c2.99,0,5.44-2.45,5.44-5.44v-6.93c0-2.99-2.45-5.44-5.44-5.44h0Z"/>
  <path class="cls-3" d="m71.37,14.01c1.17,0,2.17.99,2.17,2.17v34.9c0,1.17-.99,2.17-2.17,2.17h-17.72c-1.17,0-2.17-.99-2.17-2.17V16.18c0-1.17.99-2.17,2.17-2.17h17.72m0-4h-17.72c-3.39,0-6.17,2.77-6.17,6.17v34.9c0,3.39,2.77,6.17,6.17,6.17h17.72c3.39,0,6.17-2.77,6.17-6.17V16.18c0-3.39-2.77-6.17-6.17-6.17h0Z"/>
  <path class="cls-2" d="m72.09,66.17c.78,0,1.44.66,1.44,1.44v6.93c0,.78-.66,1.44-1.44,1.44h-19.17c-.78,0-1.44-.66-1.44-1.44v-6.93c0-.78.66-1.44,1.44-1.44h19.17m0-4h-19.17c-2.99,0-5.44,2.45-5.44,5.44v6.93c0,2.99,2.45,5.44,5.44,5.44h19.17c2.99,0,5.44-2.45,5.44-5.44v-6.93c0-2.99-2.45-5.44-5.44-5.44h0Z"/>
</svg>

</template>

<script>
export default {
    name: "DashboardIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #187382;
  }

  .cls-2 {
    fill: #b6dfce;
  }

  .cls-3 {
    fill: #65c8c9;
  }
</style>
